import "babel-polyfill";
import Vue from "vue";
import "./components";
import "./views/65Fluffy/components";
import "./views/65Mecha/components";
import "./views/65GameBoy/components";
import "./views/65Less/components";
import "./views/65LessSplit/components";
import "./views/75/components";
import "./views/80/components";
import "./views/Alice/components";
import "./views/Cyberboard/components";
import "./views/CyberboardNew/components";
import "./views/Hatsu/components";
import "./views/Mouse/components";
import "./views/MouseAM35/components";
import "./views/Magnetic/components";
import "./directives";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import App from "./App";

// 开发环境下加载设备回调测试工具
if (process.env.NODE_ENV === 'development') {
  import('./utils/DeviceCallbackTest');
}

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: (h) => h(App),
});
